import { DemandeInterventionContact } from './DemandeInterventionContact';
import { DemandeInterventionContactSurSite } from './DemandeInterventionContactSurSite';
import { HistoriqueRelanceDI } from '@/models/HistoriqueRelanceDI';

export interface DemandeIntervention {
    id?: number | undefined;
    chantierId: string;
    adresseSiteId: string;
    delaiTypeId: string;
    dateAutre?: string;
    dateCreation: string;
    phaseId: string | null;
    etatFonctionnementId: string | null;
    objet: string;
    commentaire: string;
    recurrence: boolean;
    suivi: boolean;
    contacts: DemandeInterventionContact[];
    contactSurSite: DemandeInterventionContactSurSite;
    origineDemande: string;
    adresseSiteLibelle?: string;
    pdfExist?: boolean;
    interventionsId?: number[];
    historiqueRelancesDI?: HistoriqueRelanceDI[];
}

export enum EtatDemandeIntervention {
    nonPlanifiee = 'NON_PLANIFIEE',
    planifiee = 'PLANIFIEE',
    traitee = 'TRAITEE',
    enCours = 'ENCOURS',
    refusee = 'REFUSEE'
}
